import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _typeof from "@babel/runtime/helpers/typeof";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var isOptionData = function isOptionData(value) {
  return _typeof(value) === 'object' && value.hasOwnProperty('value');
};
var isUserData = function isUserData(value) {
  return _typeof(value) === 'object' && value.hasOwnProperty('id') && value.hasOwnProperty('name') && value.hasOwnProperty('avatarUrl');
};
export var transformFormValue = function transformFormValue(value) {
  if (isOptionData(value)) {
    return value.value;
  } else if (isUserData(value) && value.type === 'user') {
    return value.id;
  }
  return value;
};
export var transformFormData = function transformFormData(formData) {
  return Object.entries(formData).reduce(function (transformedData, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return _objectSpread(_objectSpread({}, transformedData), {}, _defineProperty({}, key, Array.isArray(value) ? value.map(transformFormValue) : transformFormValue(value)));
  }, {});
};